import Vuex from 'vuex';
import Vue from 'vue';

import AppModule from './app';
import ConfiguratorModule from './configurator';

// Load
Vue.use(Vuex);

// create store
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    configurator: ConfiguratorModule
  }
});

export default store;
